import React from 'react';
import PropTypes from 'prop-types';
import { useJsApiLoader } from '@react-google-maps/api';

const GoogleContext = React.createContext({ loading: false, scriptReady: false });

function GoogleProvider({ googleMapsApiKey, googleMapStyleId, children }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'googleMapsScript',
    googleMapsApiKey,
  });

  const contextValue = React.useMemo(() => {
    const value = {
      isLoaded,
      loadError,
      scriptReady: isLoaded && !loadError,
      googleMapStyleId,
      googleMapsApiKey,
    };
    return value;
  }, [isLoaded, loadError, googleMapStyleId, googleMapsApiKey]);

  return <GoogleContext.Provider value={contextValue}>{children}</GoogleContext.Provider>;
}

GoogleProvider.propTypes = {
  googleMapsApiKey: PropTypes.string.isRequired,
  googleMapStyleId: PropTypes.string.isRequired,
  children: PropTypes.node,
};

GoogleProvider.defaultProps = {
  children: null,
};

const useGoogle = () => React.useContext(GoogleContext);

export { GoogleContext, GoogleProvider, useGoogle };
